import React from "react";
import styles from "../PanelUser/PanelLayout.module.css";
import { Link } from "react-router-dom";
import axiosInstance from "../../api/axiosConfig";

export default function ResumenAdmin() {
  const [counts, setCounts] = React.useState({
    profesionales: 0,
    sedes: 0,
    empresas: 0,
    usuarios: 0,
  });

  React.useEffect(() => {
    const token = localStorage.getItem("token");
    const headers = { Authorization: token };

    Promise.allSettled([
      axiosInstance.get("/api/professionals", { headers }),
      axiosInstance.get("/api/all-sede", { headers }),
      axiosInstance.get("/api/all-bussines", { headers }),
      axiosInstance.get("/api/all-user", { headers }),
    ]).then(([prof, sede, emp, usr]) => {
      setCounts({
        profesionales: (prof.value?.data?.data || prof.value?.data || []).length,
        sedes: (sede.value?.data?.data || sede.value?.data || []).length,
        empresas: (emp.value?.data?.data || emp.value?.data || []).length,
        usuarios: (usr.value?.data?.data || usr.value?.data || []).length,
      });
    });
  }, []);

  const stats = [
    { label: "Profesionales", sub: "registrados", value: counts.profesionales },
    { label: "Sedes", sub: "activas", value: counts.sedes },
    { label: "Empresas", sub: "registradas", value: counts.empresas },
    { label: "Usuarios", sub: "en sistema", value: counts.usuarios, orange: true },
  ];

  const quickActions = [
    { label: "Ver profesionales", sub: "Gestión de médicos", to: "/administrar/profesionales" },
    { label: "Ver sedes", sub: "Gestión de sedes", to: "/administrar/sedes" },
    { label: "Ver empresas", sub: "Gestión de empresas", to: "/administrar/empresas" },
    { label: "Ver usuarios", sub: "Gestión de usuarios", to: "/administrar/usuarios" },
    { label: "Configuración", sub: "Precios y parámetros", to: "/administrar/configuracion" },
  ];

  return (
    <>
      {/* Stats */}
      <div className={styles.statsGrid}>
        {stats.map((s) => (
          <div key={s.label} className={styles.statCard}>
            <p className={`${styles.statValue}${s.orange ? ` ${styles.orange}` : ""}`}>{s.value}</p>
            <p className={styles.statTitle}>{s.label}</p>
            <p className={styles.statSub}>{s.sub}</p>
          </div>
        ))}
      </div>

      {/* Acciones rápidas */}
      <div className={styles.card}>
        <div className={styles.cardHeader}>
          <h2 className={styles.cardTitle}>Acciones rápidas</h2>
        </div>
        <div className={styles.quickActions}>
          {quickActions.map((a) => (
            <Link key={a.to} to={a.to} className={styles.quickAction}>
              <span className={styles.quickActionTitle}>{a.label}</span>
              <span className={styles.quickActionSub}>{a.sub}</span>
            </Link>
          ))}
        </div>
      </div>
    </>
  );
}
